export default "__VITE_ASSET__B43drwW4__"